/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const createEventSubscriptionHeaderParamsSchema = z.object({
    "x-radar-user-id": z.optional(z.string().describe("Event subscription owner id — required when authenticating with the service secret instead of a bearer token"))
    }).optional()

/**
 * @description Event subscription created
 */
export const createEventSubscription201Schema = z.object({
    "id": z.string(),
"userId": z.string(),
"name": z.string(),
"targetUrl": z.string(),
"headers": z.nullable(z.object({
    
    }).catchall(z.string())),
"eventTypes": z.array(z.enum(["contact.event.detected", "contact.summary.completed"])),
"enabled": z.boolean(),
"lastSuccessAt": z.nullable(z.iso.datetime()),
"lastFailureAt": z.nullable(z.iso.datetime()),
"lastErrorMessage": z.nullable(z.string()),
"consecutiveFailureCount": z.int().min(-9007199254740991).max(9007199254740991),
"autoDisabledAt": z.nullable(z.iso.datetime()),
"createdAt": z.iso.datetime(),
"updatedAt": z.iso.datetime()
    })

/**
 * @description Invalid body
 */
export const createEventSubscription400Schema = z.any()

export const createEventSubscriptionMutationRequestSchema = z.object({
    "name": z.string().min(1).max(80),
"targetUrl": z.url(),
"eventTypes": z.array(z.enum(["contact.event.detected", "contact.summary.completed"])).min(1),
"headers": z.nullable(z.object({
    
    }).catchall(z.string().max(2048))),
"enabled": z.boolean().default(true)
    })

export const createEventSubscriptionMutationResponseSchema = z.lazy(() => createEventSubscription201Schema)